import Quadrolingual from './component';

export default Quadrolingual;
